module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAA5ElEQVQYGW3BPyuEARwA4B/ZKbJRdIPoMuKK8jFMvoAkJaOyyIBBzmoUi8FyrvxbKCLKVzDoQt1d4c49LrrIvc8TETLySvLaIomUooIjzEQSOyrSWl0p6IxmXh1EnTE1G9EM2agzquwsmrl3E2Fc2aOhaGYZA9YwEUmkfMpKq9qLZHa9SVvHbCTRp+xOh0tVc1Fn2IlNXdFgGjndzrFv0pOSmhfz2uKHBeS0W/GOshEZFziNBotqbg1KWTUSdVoc+ohfphS925aOb4YVHMdf+u2p4sGOnIpnmfhPryXXqp5s6Yn4Aub+yPcRod0BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/phone1.png
// module id = Nx2D
// module chunks = 1